import React, { useState } from "react"

import { gql, useClient, useQuery } from "hooks/urql"

import NotificationContainer from "components/NotificationContainer"
import Pagination from "components/Pagination"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import Message from "../Details/Message"

export type MessageThreadDetailsProps = {
  id: string
}

const MessageThreadDetails: React.FC<MessageThreadDetailsProps> = ({ id }) => {
  const client = useClient()
  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: messageThreadQuery,
    variables: { id, page },
    client,
  })

  return (
    <>
      <UrqlLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            <NotificationContainer />
            <h1>{viewer.messageThread.title}</h1>
            {viewer.messageThread.messages.data.map(message => (
              <Message key={message.id} message={message} viewer={viewer} />
            ))}
            <Pagination
              totalPages={viewer.messageThread.messages.totalPages}
              currentPage={page}
              changePage={setPage}
            />
          </>
        )}
      </UrqlLoadingIndicator>
    </>
  )
}

const messageThreadQuery = gql`
  query MessageThread($id: ID!, $page: Int) {
    viewer {
      id
      type
      messageThread(id: $id) {
        id
        title
        users {
          id
          messagingDisplayName
          avatar {
            thumbUrl
          }
        }
        messages(page: $page) {
          totalPages
          data {
            id
            content
            createdAt
            author {
              id
              messagingDisplayName
              avatar {
                thumbUrl
              }
            }
            attachment {
              filename
              contentType
              downloadUrl
              url
              thumbUrl
              previewUrl
            }
          }
        }
      }
    }
  }
`

export default MessageThreadDetails
